/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LeadsService {
  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static createChaosEngineeringLead(requestBody?: { chaos_fault_name: string }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/leads/create-chaos-engineering-lead',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
